module.exports = __webpack_public_path__ + "static/img/图层 3@2x.f88eea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/图层 3@2x.jpg
// module id = lXOf
// module chunks = 20